import { Box, InputBase, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postUserSignin } from "../../api/signin";
import { setToken } from "../../api/token";
import LockIcon from "../../assets/SVG/lockIcon";
import ProfileIcon from "../../assets/SVG/profileIcon";
import { InputPassword } from "../signin/inputPassword";
import InputLoginForm from "./inputLoginForm";

export default function LoginForm({ lg }) {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const md = useMediaQuery("(max-width:450px)");
  const navigate = useNavigate();
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (password && username) {
          postUserSignin({
            nid: username,
            password: password,
          })
            .then((res) => {
              setToken(res);
              navigate("../");
            })
            .catch((err) => {
              // toast.error(err.data)
            });
        } else {
          toast.error("لطفا فیلد هارا پر کنید");
        }
      }}
    >
      <Box display="grid" justifyContent={"center"}>
        <Typography
          sx={{
            color: "#2B2B2B",
            textAlign: "right",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "120%",
            mb: "15px",
          }}
        >
          ورود
        </Typography>
        <InputLoginForm
          width={md ? "250px" : ""}
          inputProps={{ maxLength: 10 }}
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          lable="نام کاربری"
          placeholder={"نام کاربری"}
        >
          <ProfileIcon />
        </InputLoginForm>
        <InputLoginForm
          width={md ? "250px" : ""}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          password
          lable="رمز عبور"
          placeholder={"رمز عبور"}
        >
          <LockIcon />
        </InputLoginForm>
        {/* <InputPassword /> */}
        <Link to="/forgetPassword">
          <Typography
            sx={{
              color: "#6CBBC7",
              textAlign: "right",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "120%",
              cursor: "pointer",
              my: "10px",
            }}
          >
            فراموشی رمز عبور
          </Typography>
        </Link>
        <button
          type="submit"
          style={{
            display: "flex",
            marginTop: "20px",
            padding: "12px 24px",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
            background: "#6CBBC7",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            border: "none",
            color: "white",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          ورود
        </button>
        <Box display="flex" justifyContent="center" mt="20px">
          <Typography sx={{ fontSize: "16px", color: "#414F4Ds" }}>
            حساب فعالی ندارید؟
          </Typography>
          <Link to="/signin">
            <Typography
              sx={{
                fontSize: "16px",
                color: "#6CBBC7",
                mr: "5px",
                cursor: "pointer",
              }}
            >
              ثبت نام کنید
            </Typography>
          </Link>
        </Box>
      </Box>
    </form>
  );
}
